import { call, put, select, takeLatest } from 'redux-saga/effects';
import axiosInstance from '../../services/AuthHeader';
import {
  clearQuestionnaireResponseFailure,
  setQuestionnaireResponseFailure,
  setQuestionnaireResponses,
} from '../reducers/results';
import { selectPatientId } from 'redux/reducers/session';

export const SAGA_GET_QUESTIONNAIRE_RESPONSE = 'SAGA_GET_QUESTIONNAIRE_RESPONSE';

export function sendGetQuestionnaireResponses() {
  return { type: SAGA_GET_QUESTIONNAIRE_RESPONSE };
}

const handleGetQuestionnaireResponse = async (patientId) =>
  axiosInstance
    .get(
      '/fhir/QuestionnaireResponse?status=completed&questionnaire=check-in-survey&patient=' +
        patientId,
    )
    .then((res) => res.data);

const handleGetNextPage = async (url) => axiosInstance.get(url).then((res) => res.data);

const getNextPageUrl = (fhirBundleResponse) => {
  // Collect all of the links in the bundle response.
  const links = fhirBundleResponse?.link;
  if (!!links && links.length > 0) {
    // Go through the links and look for any with relation = 'next'.  If we find it, then return the associated url.
    const nextLink = links.find((link) => link.relation === 'next');
    if (!!nextLink) {
      return nextLink.url;
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export function* getQuestionnaireResponse() {
  // Clear any errors.
  yield put(clearQuestionnaireResponseFailure());
  try {
    let patientId = yield select(selectPatientId);
    let questionnaireResponses = [];
    let response = yield call(handleGetQuestionnaireResponse, patientId);

    // Collect the questionnaire responses.
    questionnaireResponses = questionnaireResponses.concat(response.entry);

    // Do the paging if necessary.
    let nextPageUrl = getNextPageUrl(response);
    while (!!nextPageUrl) {
      response = yield call(handleGetNextPage, nextPageUrl);
      questionnaireResponses = questionnaireResponses.concat(response.entry);
      nextPageUrl = getNextPageUrl(response);
    }

    yield put(setQuestionnaireResponses(questionnaireResponses));
  } catch (error) {
    yield put(setQuestionnaireResponseFailure(error.response));
  }
}

export function* watchForGetQuestionnaireResponse() {
  yield takeLatest(SAGA_GET_QUESTIONNAIRE_RESPONSE, getQuestionnaireResponse);
}
